<template>
  <div>
    <q-tabs
      :model-value="tab"
      active-color="primary"
      active-bg-color="grey-1"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-route-tab
        name="unreviewed"
        :label="'Unreviewed (' + client.totalUnreviewed + ')'"
        :to="tabRoute('unreviewed')"
      />
      <q-route-tab
        name="escalated"
        label="Escalated"
        :to="tabRoute('escalated')"
      >
        <q-badge
          color="warning"
          floating
        >
          {{ client.totalEscalated }}
        </q-badge>
      </q-route-tab>
      <q-route-tab
        name="flagged"
        :label="'Flagged (' + client.totalFlagged + ')'"
        :to="tabRoute('flagged')"
      />
      <q-route-tab
        name="timeline"
        :label="'Timeline (' + client.totalTimeline + ')'"
        :to="tabRoute('timeline')"
      />
      <q-route-tab
        name="reports"
        :label="'Reports (' + client.totalReports + ')'"
        :to="tabRoute('reports')"
      />
      <q-route-tab
        name="search"
        label="Search"
        :to="tabRoute('search')"
      />
      <q-route-tab
        name="people"
        :label="'People (' + client.totalPersons + ')'"
        :to="tabRoute('people')"
      />
    </q-tabs>

    <q-tab-panels
      :model-value="tab"
      class="bg-grey-1 q-px-md"
      animated
    >
      <q-tab-panel
        name="unreviewed"
        class="no-scroll"
      >
        <unreviewed-client-posts :client="client" />
      </q-tab-panel>
      <q-tab-panel
        name="escalated"
        class="no-scroll"
      >
        <escalated-client-posts :client="client" />
      </q-tab-panel>
      <q-tab-panel
        name="flagged"
        class="no-scroll"
      >
        <flagged-client-posts :client="client" />
      </q-tab-panel>
      <q-tab-panel name="timeline">
        <timeline :client="client" />
      </q-tab-panel>
      <q-tab-panel name="search">
        <searches :client-id="client.id" />
      </q-tab-panel>
      <q-tab-panel name="reports">
        <reports :client="client" />
      </q-tab-panel>
      <q-tab-panel name="people">
        <PeopleTab :client="client" />
      </q-tab-panel>
    </q-tab-panels>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { DetailedClient } from '@/type';
import EscalatedClientPosts from '@/social/post/list/client/EscalatedClientPosts.vue';
import FlaggedClientPosts from '@/social/post/list/client/FlaggedClientPosts.vue';
import UnreviewedClientPosts from '@/social/post/list/client/UnreviewedClientPosts.vue';
import Reports from '@/report/Reports.vue';
import Searches from '@/social/post/search/Searches.vue';
import PeopleTab from '@/analysis/person/PeopleTab.vue';
import Timeline from './Timeline.vue';

export default defineComponent({
  components: {
    Searches,
    EscalatedClientPosts,
    FlaggedClientPosts,
    UnreviewedClientPosts,
    Timeline,
    Reports,
    PeopleTab,
  },
  props: {
    client: {
      type: Object as () => DetailedClient,
      required: true,
    },
    tab: {
      type: String,
      default: 'overview',
    },
  },
  watch: {
    tab(): void {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
  methods: {
    tabRoute(tab?: string): object {
      return {
        name: 'client_profile_tab',
        params: {
          clientId: this.client.id,
          tab,
        },
      };
    },
  },
});
</script>
